import React, { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import Services from "@/components/Services";
import MobileVan from "@/components/MobileVan";
import ShipIn from "@/components/ShipIn";
import NationwidePromo from "@/components/NationwidePromo";
import Diagnostic from "@/components/Diagnostic";
import Pricing from "@/components/Pricing";
import Story from "@/components/Story";
import Process from "@/components/Process";
import IntakeForm from "@/components/IntakeForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";
import NationwidePage from "@/pages/NationwidePage";
import ThankYouLabel from "@/pages/ThankYouLabel";
import TrackLabel from "@/pages/TrackLabel";
import { trackEvent } from "@/utils/analytics";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-paper p-8 text-center">
          <div>
            <p className="font-display text-2xl font-bold text-ink">Something went sideways.</p>
            <p className="mt-2 text-slate-500">Call or text (716) 256-6630 — we'll sort you out.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function MainSite() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -84, duration: 1.2 });
      }
    };
    document.addEventListener("click", onAnchor);

    const onTrack = (e) => {
      const a = e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
      if (!a) return;
      const href = a.getAttribute("href");
      trackEvent(href.startsWith("tel:") ? "call_click" : "email_click", { href });
    };
    document.addEventListener("click", onTrack);

    return () => {
      document.removeEventListener("click", onAnchor);
      document.removeEventListener("click", onTrack);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-paper">
      <Nav />
      <main>
        <Hero />
        <BrandMarquee />
        <Services />
        <MobileVan />
        <ShipIn />
        <NationwidePromo />
        <Diagnostic />
        <Pricing />
        <Story />
        <Process />
        <IntakeForm />
        <FAQ />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/nationwide-dental-handpiece-repair" element={<NationwidePage />} />
          <Route path="/label-request-thank-you" element={<ThankYouLabel />} />
          <Route path="/track-label" element={<TrackLabel />} />
          <Route path="*" element={<MainSite />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;